export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-upload-cloud-line',
      title: 'List Your Item',
      description: 'Upload photos, add details, and choose whether to give away or swap your items with the community.',
      bgColor: 'bg-emerald-50',
      link: '#'
    },
    {
      number: '02',
      icon: 'ri-arrow-left-right-line',
      title: 'Find a Match',
      description: 'Browse items nearby, discover what you need, and propose swaps with other community members.',
      bgColor: 'bg-rose-50',
      link: '#'
    },
    {
      number: '03',
      icon: 'ri-hand-heart-line',
      title: 'Complete Swap',
      description: 'Chat, arrange meetup, and exchange items safely. Rate your experience and build trust in the community.',
      bgColor: 'bg-amber-50',
      link: '#'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider uppercase mb-4">
            The Process
          </div>
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-4">
            Simple Steps to<br />Start Swapping
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join our community and make a difference in three easy steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className={`${step.bgColor} rounded-3xl p-8 hover:shadow-xl transition-all duration-300 cursor-pointer group`}>
              <div className="text-5xl font-bold text-gray-300 mb-6">{step.number}</div>
              
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${step.icon} text-3xl text-teal-600`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{step.description}</p>

              <a href={step.link} className="inline-flex items-center gap-2 text-teal-600 font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap">
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
